<template>
  <div class="add-menu">
    <h1>Agregar Nuevo Menú</h1>
    
    <div class="card p-4 bg-light">
      <form @submit.prevent="submitForm">
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre</label>
          <input 
            type="text" 
            class="form-control" 
            id="nombre" 
            :value="menu.Nombre"
            @input="updateField('Nombre', $event.target.value)"
            required
          >
        </div>
        <div class="mb-3">
          <label for="menuPadre" class="form-label">Menu Padre</label>
          <select class="form-select" :value="menu.MenuPadre" @change="handleMenuPadreChange($event.target.value || null)">
            <option :value="null">-- Raíz --</option>
            <option v-for="parent in parentMenus" :key="parent.MenuId" :value="parent.MenuId">
              {{ parent.Nombre }}
            </option>
          </select>
        </div>
        <div class="mb-3">
          <label for="orden" class="form-label">Orden</label>
          <input 
            type="number" 
            class="form-control" 
            id="orden" 
            :value="menu.Orden"
            @input="updateField('Orden', parseInt($event.target.value) || 0)"
          >
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary" :disabled="saving">
            {{ saving ? 'Guardando...' : 'Guardar Menú' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="goBack">
            Cancelar
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import { AddMenuController } from '../controllers/AddMenuCtrl.js';

export default {
  name: 'AddMenuView',
  components: {
  },
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new AddMenuController()
    }
  },
  computed: {
    menu() {
      return this.controller.getMenu();
    },
    parentMenus() {
      return this.controller.getParentMenus();
    },
    saving() {
      return this.controller.isSaving();
    },
    loading() {
      return this.controller.isLoading();
    },
    error() {
      return this.controller.getError();
    }
  },
  async mounted() {
    try {
      await this.controller.init();
    } catch (error) {
      console.error('Error al inicializar:', error);
      this.$alert.error('Error al cargar los datos iniciales.');
    }
  },
  methods: {
    async submitForm() {
      try {
        const result = await this.controller.saveMenu();
        
        if (result.success) {
          this.$alert.success(result.message);
          this.$router.push('/menus');
        } else {
          this.$alert.error(result.message || 'Error al guardar el menú.');
        }
      } catch (error) {
        console.error('Error saving menu:', error);
        this.$alert.error(this.controller.getError() || 'Error al guardar el menú. Por favor, intente de nuevo.');
      }
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    handleMenuPadreChange(value) {
      this.controller.handleMenuPadreChange(value);
    },
    goBack() {
      this.$router.push('/menus');
    }
  }
}
</script>

<style scoped>
.add-menu {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}
</style>
